import {
  UNALLOCATED,
  DECLINED,
  PENDING,
  ACCEPTED,
  sortBookingsByCollectionDateAscending,
  getLeastProgressedTrip,
  getActiveTrips,
} from '../../common/helpers';
import { applyDateRangeFilter } from '$app/shared/components/DateRangeFilter';

export const formatBookingsForColumn = (bookings) =>
  bookings.map((booking) => ({
    template: {},
    booking,
    drivers: [],
    id: `${booking.bookingid} `,
    draggable: false,
  }));

export const removeIrrelevantBookings = (bookings, columnName) => {
  const bookingsForColumn = bookings.filter((booking) => {
    const activeTrips = getActiveTrips(booking.trips);

    if (!activeTrips.length) return false;

    const leastProgressedTrip = getLeastProgressedTrip(activeTrips);

    // If no trip type or allocation status that we expect, still show booking
    if (!leastProgressedTrip && columnName === UNALLOCATED) return true;

    return leastProgressedTrip?.allocationStatus === columnName;
  });
  return bookingsForColumn;
};

const getBookingsForColumn = (bookings, columnName) => {
  const relevantBookings = removeIrrelevantBookings(bookings, columnName);

  const sortedBookings = sortBookingsByCollectionDateAscending(relevantBookings);

  return formatBookingsForColumn(sortedBookings);
};

const applySegmentFilter = (booking, filteredSegment) => {
  if (!filteredSegment || filteredSegment === 'all') return true;
  if (filteredSegment === booking.segment) return true;
  return false;
};

const applyGarageFilter = (booking, filteredGarage) => {
  if (!filteredGarage) return true;
  const stringifiedBooking = JSON.stringify(booking);
  return stringifiedBooking.includes(filteredGarage);
};

const applyDriverFilter = (booking, filteredDriver) => {
  if (!filteredDriver) return true;
  return booking.trips.find(({ pickerId }) => {
    if (!pickerId) return false;
    return pickerId.toString() === filteredDriver;
  });
};

export const applyUserSelectedFilters = (bookings, filters) => {
  const { filteredSegment, filteredDateRange, filteredGarage, filteredDriver } = filters;
  return bookings.filter(
    (booking) =>
      applySegmentFilter(booking, filteredSegment) &&
      applyDateRangeFilter(booking, filteredDateRange) &&
      applyGarageFilter(booking, filteredGarage) &&
      applyDriverFilter(booking, filteredDriver)
  );
};

// eslint-disable-next-line import/prefer-default-export
export const getColumnsWithBookings = (bookings, filters) => {
  const columnTitles = [
    {
      type: UNALLOCATED,
      title: 'Unallocated',
    },
    {
      type: DECLINED,
      title: 'Declined',
    },
    {
      type: PENDING,
      title: 'Pending',
    },
    {
      type: ACCEPTED,
      title: 'Accepted',
    },
  ];

  const filteredBookings = applyUserSelectedFilters(bookings, filters);
  return columnTitles.map((col) => {
    const cards = getBookingsForColumn(filteredBookings, col.type);

    return {
      id: col.type,
      title: col.title,
      label: cards.length.toString() || undefined,
      cards,
    };
  });
};
